import { render, staticRenderFns } from "./fqXiangQing.vue?vue&type=template&id=d47bdc9e&scoped=true&"
import script from "./fqXiangQing.vue?vue&type=script&lang=js&"
export * from "./fqXiangQing.vue?vue&type=script&lang=js&"
import style0 from "./fqXiangQing.vue?vue&type=style&index=0&id=d47bdc9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47bdc9e",
  null
  
)

export default component.exports